import { mask } from "@titou10/v-mask";
import Vue from "vue";

Vue.directive("mask", mask);
